<template>
	<div class="quick-search">
		<site-header :userAuthenticated="true"></site-header>
		<breadcrumb>
			<router-link to="/" class="active">Home</router-link>
			<print-icon></print-icon>
		</breadcrumb>

		<div class="container">
			<side-menu>
				<nav>
					<router-link to="/search">
						<input-button :btn-class="'btn-primary'" class="btn-start-new-search">Start new search <font-awesome-icon icon="search" /></input-button>
					</router-link>
				</nav>
			</side-menu>

			<main-content>
				<h1>Quick Search</h1>
				<p>Company name or number</p>
				<form @submit.prevent="newSearch" action="" class="form-fields">
					<text-input class="search-by-company" :identifier="'companyName'" :attrs="{placeholder: 'Search by company name or number'}" v-model="searchTerm"></text-input>

					<input-button class="search-btn" :btn-class="'btn-grey'">Search <font-awesome-icon icon="arrow-right" /></input-button>
					<font-awesome-icon icon="spinner" v-if="searchLoading" />
				</form>
				<p>Postcode</p>
				<form @submit.prevent="newPostcodeSearch" action="" class="form-fields">
					<text-input class="search-by-company" :identifier="'companyName'" :attrs="{placeholder: 'Search by postcode'}" v-model="searchPostcodeTerm"></text-input>

					<input-button class="search-btn" :btn-class="'btn-grey'">Search <font-awesome-icon icon="arrow-right" /></input-button>
					<font-awesome-icon icon="spinner" v-if="postcodeSearchLoading" />
				</form>

				<div class="results" v-if="results.length > 0">
					<div class="pagination">
						<p>
							<strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultCount}}</strong> companies found
						</p>
						<button class="fake-anchor" @click="previousResults"><font-awesome-icon icon="arrow-left" /> Previous</button>
						|
						<button class="fake-anchor" @click="nextResults">Next <font-awesome-icon icon="arrow-right" /></button>
					</div>

					<ul class="no-style-list">
						<li class="result-item" v-for="result in results" :key="result">
							<router-link :to="'/company-details/' + result.companyId">{{result.companyName}}</router-link>
							<p>{{result.registeredNumber}}</p>
							<p>{{result.postcode}}</p>
							<p v-if="result.region">{{result.region.name}}</p>
						</li>
					</ul>

					<div class="pagination">
						<p>
							<strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultCount}}</strong> companies found
						</p>
						<button class="fake-anchor" @click="previousResults"><font-awesome-icon icon="arrow-left" /> Previous</button>
						|
						<button class="fake-anchor" @click="nextResults">Next <font-awesome-icon icon="arrow-right" /></button>
					</div>

					<button class="fake-anchor fl-r" @click="chooseAllCompanies">Select all companies</button>
				</div>


				<div class="results" v-if="results.length == 0">
					<p>No results found</p>
				</div>

			</main-content>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
	import SiteHeader from '../components/header/SiteHeader'
	import InputButton from '../components/reusable/InputButton'
	import SideMenu from '../components/reusable/SideMenu'
	import Breadcrumb from '../components/reusable/Breadcrumb'
	import MainContent from '../components/reusable/MainContent'
	import TextInput from '../components/reusable/TextInput'
	import SelectInput from '../components/reusable/SelectInput'
	import PrintIcon from '../components/other/PrintIcon'
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import { mapState, mapActions, mapMutations } from 'vuex'
	import { isSet } from '../helpers/helpers'
	import router from '../router'

	export default {
		name: 'QuickSearch',
		data() {
			return {
				searchLoading: false,
				postcodeSearchLoading: false
			}
		},
		components: {
			SiteHeader,
			InputButton,
			SideMenu,
			Breadcrumb,
			MainContent,
			TextInput,
			SelectInput,
			PrintIcon,
			FontAwesomeIcon
		},
		computed: {
			...mapState({
				results: state => state.quicksearchmodule.results,
				resultCount: state => state.quicksearchmodule.resultCount
			}),
			searchTerm: {
				get() {
					return this.$store.state.quicksearchmodule.searchTerm
				},
				set(value) {
					this.updateSearchTerm(value)
				}
			},
			searchPostcodeTerm: {
				get() {
					return this.$store.state.quicksearchmodule.searchPostcodeTerm
				},
				set(value) {
					this.updateSearchPostcodeTerm(value)
				}
			},
			take: {
				get() {
					return this.$store.state.quicksearchmodule.take
				},
				set(value) {
					this.updateTake(value)
				}
			},
			skip: {
				get() {
					return this.$store.state.quicksearchmodule.skip
				},
				set(value) {
					this.updateSkip(value)
				}
			},
			lowerPage() {
				return this.skip;
			},
			upperPage() {

				if ((this.take + this.skip) < this.resultCount) return this.take + this.skip;
				else return this.resultCount;
			},
			searchType: {
				get() {
					return this.$store.state.quicksearchmodule.searchType
				},
				set(value) {
					this.updateSearchType(value)
				}
			},
		},
		methods: {
			...mapActions('quicksearchmodule', [
				'doQuickSearch',
				'chooseAllCompanies'
			]),
			...mapMutations('quicksearchmodule', [
				'updateResults',
				'updateSearchTerm',
				'updateSearchPostcodeTerm',
				'updateTake',
				'updateSkip',
				'updateSearchType'
			]),
			newSearch() {
				this.skip = 0;
				this.searchType = 'name';
				this.searchPostcodeTerm = '';
				this.quickSearchByCompany();
			},
			newPostcodeSearch() {
				this.skip = 0;
				this.searchType = 'postcode';
				this.searchTerm = '';
				this.quickSearchByCompany();
			},
			quickSearchByCompany() {

				if (isSet(this.searchTerm) && this.searchType === 'name') {
					this.searchLoading = true;
					this.doQuickSearch({ searchTerm: this.searchTerm, take: this.take, skip: this.skip }).then(() => {
						this.searchLoading = false;
					});
				}
				else if (isSet(this.searchPostcodeTerm) && this.searchType === 'postcode') {
					this.postcodeSearchLoading = true;
					this.doQuickSearch({ searchTerm: this.searchPostcodeTerm, take: this.take, skip: this.skip }).then(() => {
						this.postcodeSearchLoading = false;
					});
				}
			},
			nextResults() {
				if ((this.skip + this.take) < this.resultCount) {
					this.skip = this.skip + this.take;
					this.quickSearchByCompany();
				}
			},
			previousResults() {
				if ((this.skip - this.take) >= 0) {
					this.skip = this.skip - this.take;
					this.quickSearchByCompany();
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.quick-search {
		padding-bottom: 40px;
	}

	.container {
		clear: both;

		@media only screen and (min-width: 800px) {
			display:flex;
		}
	}

	.btn-start-new-search {
		svg{
			vertical-align: -.125em !important;
			width: 1em !important;
			height: 15px;
		}
	}

	.side-menu {
		margin-top: 30px;
		margin-left: 30px;

		@media only screen and (max-width: 800px) {
			margin-right: 30px;
		}
	}

	.main-content {
		margin: 30px 30px 0 30px;
		flex-grow: 1;
	}

	.h1 {
		border-bottom: 1px solid #dadada;
		padding-bottom: 8px;
		margin-bottom: 20px;
	}

	.form-fields {
		max-width: 1000px;

		@media only screen and (min-width: 1200px) {
			display:flex;
		}
	}

	.search-by-company {
		flex-basis: 600px;

		@media only screen and (max-width: 1200px) {
			margin-bottom:20px;
		}
	}

	.search-btn {
		float:left;
		margin-right: 15px;
		margin-bottom: 40px;

		svg{
			height: 15px;
			vertical-align: -.125em !important;
			width: 1em !important;
		}

		@media only screen and (min-width: 1200px) {
			margin-left: 20px;
			margin-bottom: 20px;
		}
	}

	.results {
		margin-top: 20px;
		margin-bottom: 40px;
		clear:both;

		ul li
		{
			padding: 20px;
			p{
				margin: 7px 0;
			}

			p:last-child {
				margin-bottom: 0;
			}
		}

		ul li:nth-child(odd) {
			background: #fbfbfb;
		}
	}

	.pagination{
		margin-bottom:30px;

		button{
			cursor:pointer;
		}

		button:nth-of-type(1){
			padding:0;
			margin-right:10px;

			svg{
				margin-right:10px;
			}
		}s

		button:nth-of-type(2){
			padding:0;
			margin-left:10px;

			svg{
				margin-left:10px;
			}
		}
	}
</style>